import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot} from '@angular/router';
import {AuthenticationService} from '../authentication.service';
import {UserRolePipe} from '../../pipes/user-role.pipe';
import {environment} from '../../../../environments/environment.dev';

@Injectable()
export class RoleGuard implements CanActivate {
    constructor(
        private userRolePipe: UserRolePipe,
        private roles: string[]
    ) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const POSSIBLE_ROLES = environment.userRoles.All;
        const CURRENT_USER_ROLES: string[] = AuthenticationService.getStoredAuthData()?.user?.roles ?? [];

        if (!CURRENT_USER_ROLES.length) {
            return false;
        }

        const roles = route.data.roles as Array<string>;

        if (!roles) {
            return false;
        }

        return roles.some(role => {
            if (POSSIBLE_ROLES.some(rols => CURRENT_USER_ROLES.includes(rols))) {
                return [role].some(rols => CURRENT_USER_ROLES.includes(rols));
            } else {
                return false;
            }
        });
    }
}
